export default {
    initEnvironment: () => {
        return {
            url: '/simulationenr/initialize',
            method: 'GET'
        };
    }
};



// WEBPACK FOOTER //
// ./environments/simulationenr/api.js